exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header {\n  display: flex;\n  margin-bottom: 10px; }\n  .header :first-child {\n    width: 92%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ConfigPanel/ControlConfig/ControlConfig.scss
// module id = 867
// module chunks = 0